/* Routine fuel calculator.
   Model parameters and sports come from the section schema, so they can be
   retuned in the theme editor without touching this file. */
(function(){
  function boot(root){
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-fc-config]').textContent); }
    catch(e){ return; }
    if(!cfg.sports || !cfg.sports.length) return;

    var q = function(sel){ return root.querySelector(sel); };
    var host = q('[data-fc-sports]');
    var wt = q('[data-fc-weight]'), mins = q('[data-fc-mins]'), eat = q('[data-fc-eat]');
    var meal = q('[data-fc-meal]');
    var wtOut = q('[data-fc-weight-out]'), minsOut = q('[data-fc-mins-out]');
    var f1 = q('[data-fc-fill-1]'), f2 = q('[data-fc-fill-2]');
    var e1 = q('[data-fc-empty-1]'), e2 = q('[data-fc-empty-2]');
    var e1l = q('[data-fc-empty-1-l]'), e2l = q('[data-fc-empty-2-l]');
    var eWas = q('[data-fc-empty-was]'), eNow = q('[data-fc-empty-now]');
    var m1 = q('[data-fc-mark-1]'), m2 = q('[data-fc-mark-2]');
    var v1 = q('[data-fc-val-1]'), v2 = q('[data-fc-val-2]');
    var vBig = q('[data-fc-verdict]'), vSub = q('[data-fc-verdict-sub]');
    var sportName = q('[data-fc-sport-name]');
    var cur = cfg.sports[0];

    cfg.sports.forEach(function(s,i){
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = s.name;
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function(){
        cur = s;
        Array.prototype.forEach.call(host.children, function(c){ c.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        mins.value = s.minutes;
        calc();
      });
      host.appendChild(b);
    });

    /* {spare} prints the number; {spare:minute} prints "1 minute" or
       "8 minutes". Without it the copy said "1 minutes of headroom". */
    function fill(tpl, map){
      return String(tpl).replace(/\{(\w+)(?::(\w+))?\}/g, function(_, k, unit){
        var v = map[k];
        if (v === undefined) return '';
        if (!unit) return v;
        return v + ' ' + unit + (Math.abs(+v) === 1 ? '' : 's');
      });
    }

    function calc(){
      var lb = +wt.value, play = +mins.value, absorb = +eat.value;
      var mealHrs = meal ? +meal.value : 4;
      var mealFactor = (cfg.mealFactors && cfg.mealFactors[String(mealHrs)]) || 1;
      wtOut.textContent = lb + ' ' + cfg.weightUnit;
      minsOut.textContent = play + ' min';
      sportName.textContent = cur.name;

      var kg = lb / 2.2046;
      /* Hours since a real meal drains the athlete's own tank. This is the
         bit the section has always claimed ("lunch at eleven, game at six")
         and the maths never actually did. */
      var available = kg * cfg.availablePerKg * mealFactor;
      var burn = kg * cur.rate;
      var barG = cfg.barCarbs * absorb;

      var w1 = (available * cfg.fadeThreshold) / burn;
      var w2 = ((available + barG) * cfg.fadeThreshold) / burn;
      var gain = w2 - w1;

      /* Scale both tracks to the outing itself. Scaling to whichever number is
         largest made a 4-minute shortfall and a 12-minute surplus look like two
         near-identical bars, which is the opposite of what the model found. */
      var scale = play;
      var p1 = Math.min(100, (w1 / scale) * 100);
      var p2 = Math.min(100, (w2 / scale) * 100);
      f1.style.width = p1 + '%';
      f2.style.width = p2 + '%';

      var empty1 = Math.max(0, play - w1), empty2 = Math.max(0, play - w2);
      if (e1) { e1.style.width = (100 - p1) + '%'; e1.classList.toggle('on', empty1 >= 0.5); }
      if (e2) { e2.style.width = (100 - p2) + '%'; e2.classList.toggle('on', empty2 >= 0.5); }
      /* the label only fits once the zone is wide enough; below that the
         readout underneath carries the number instead */
      function label(el, mins, pct){
        if (!el) return;
        el.textContent = (mins >= 0.5 && (100 - pct) >= 13) ? Math.round(mins) + ' min empty' : '';
      }
      label(e1l, empty1, p1);
      label(e2l, empty2, p2);

      /* the whistle is the end of the track now, so the marker sits at the end */
      m1.style.left = '100%'; m2.style.left = '100%';

      /* past the whistle there is no more game to cover, so report the spare */
      /* Both gauges report against the same yardstick — minutes of the outing
         covered out of minutes played. "+8 spare" was a different unit from
         "61 of 65" sitting two lines above it, which is what made the pair
         unreadable. The surplus is headroom, not a feature, so it is explained
         in words in the verdict rather than shown as a bare number here. */
      v1.textContent = w1 >= play ? 'covers all ' + play + ' min'
                                  : Math.round(w1) + ' of ' + play + ' min';
      v2.textContent = w2 >= play ? 'covers all ' + play + ' min'
                                  : Math.round(w2) + ' of ' + play + ' min';

      if (eWas) eWas.textContent = Math.round(empty1);
      if (eNow) eNow.textContent = Math.round(empty2);

      var left = Math.max(0, play - w1);
      var map = { fade: Math.round(w1), fadeWith: Math.round(w2), gain: Math.round(gain),
                  play: play, sport: (cur.name || '').toLowerCase(),
                  left: Math.round(left), empty: Math.round(empty1), emptyWith: Math.round(empty2),
                  spare: Math.round(Math.max(0, w2 - play)),
                  barCarbs: cfg.barCarbs, lb: lb, mealHours: mealHrs };
      var big, sub;
      if (w1 >= play)            { big = cfg.copy.coveredHeading;  sub = cfg.copy.coveredBody; }
      else if (w2 >= play)       { big = cfg.copy.closedHeading;   sub = cfg.copy.closedBody; }
      else                       { big = cfg.copy.shortHeading;    sub = cfg.copy.shortBody; }
      vBig.innerHTML = fill(big, map);
      vSub.textContent = fill(sub, map);
    }

    wt.addEventListener('input', calc);
    mins.addEventListener('input', calc);
    eat.addEventListener('change', calc);
    if (meal) meal.addEventListener('change', calc);
    calc();
  }

  function init(){
    document.querySelectorAll('[data-fuel-calculator]').forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
